import ActionButton from 'components/GlobalModals/SavedForLaterModal/ActionButton/ActionButton.f';

export default ActionButton;
